import type {CSSProperties} from 'react';
import type {Inches} from '../../render-v2-d';

/**
 * Horizontal mat rails for `#inner-content`.
 *
 * `contentWidth` already includes `railLeft + railRight`. These paddings reserve
 * each side inside that declared width (`box-sizing: border-box`) so unequal
 * rails stay independent without growing the frame.
 */
export function innerContentSideRailStyle(railLeft: Inches, railRight: Inches, inchToPx: (inches: number) => string): Pick<CSSProperties, 'boxSizing' | 'paddingLeft' | 'paddingRight'> {
    return {
        boxSizing: 'border-box',
        paddingLeft: inchToPx(railLeft),
        paddingRight: inchToPx(railRight),
    };
}
